import { apiFetch } from "../lib/api";

export interface PreopenDeployment {
  deployment: string;
  connection: string;
  ok: boolean;
  problems: string[];
}

export interface PreopenStatus {
  /** False before the first check of the process has run. */
  checked: boolean;
  /** The times the check runs, e.g. ["09:10", "09:14"]. */
  schedule: string[];
  market_open: string;
  date?: string;
  checked_at?: string;
  ok?: boolean;
  deployments?: PreopenDeployment[];
}

export async function getPreopenStatus(): Promise<PreopenStatus> {
  return apiFetch<PreopenStatus>("/preopen/status");
}
